import React from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  glow?: boolean;
  hover?: boolean;
  onClick?: () => void;
}

const GlassCard: React.FC<GlassCardProps> = ({ children, className = '', glow = false, hover = true, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`
        relative backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl
        ${glow ? 'shadow-2xl shadow-cyan-500/25' : 'shadow-xl shadow-black/25'}
        ${hover ? 'hover:bg-white/15 hover:border-white/30 transition-all duration-300' : ''}
        ${onClick ? 'cursor-pointer active:scale-[0.98]' : ''}
        ${className}
      `}
      style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
      }}
    >
      {/* 内部光晕效果 */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/5 to-transparent pointer-events-none" />

      {/* 顶部高光 */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent rounded-t-2xl" />

      {children}
    </div>
  );
};

export default GlassCard;
